var _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDeleteGray = function SvgDeleteGray(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 5.8335L2.00065 19.1668H12.0007L13.6673 5.8335H0.333984ZM2.22195 7.50016L3.47195 17.5002H10.5293L11.7793 7.50016H2.22195Z",
    fill: "#ADC9D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.333984 2.5H13.6673V4.16667H0.333984V2.5Z",
    fill: "#ADC9D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 0.833496H8.66732V2.50016H5.33398V0.833496Z",
    fill: "#ADC9D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 8.94043L6.48729 15.5817L4.82696 15.727L4.24593 9.08569L5.90625 8.94043Z",
    fill: "#ADC9D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54688 15.5815L8.12791 8.94025L9.78824 9.08551L9.2072 15.7268L7.54688 15.5815Z",
    fill: "#ADC9D5"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_gray.d3a25bea.svg";
export { ForwardRef as ReactComponent };